export default {
  state: {
    restrictionList: null,
    restrictionTotalCount: null,
    restrictionSingle: null
  },
  mutations: {
    setRestrictionList (state, payload) {
      state.restrictionList = payload
    },
    setRestrictionTotalCount (state, payload) {
      state.restrictionTotalCount = payload
    },
    setRestrictionSingle (state, payload) {
      state.restrictionSingle = payload
    }
  },
  actions: {
    getRestrictionList ({commit, dispatch}, {mode, offset, limit}) {
      const url = '/admin/restrict/list?access_token=' + this.getters.accessToken + '&mode=' + mode + '&offset=' + offset + '&limit=' + limit
      dispatch('apiGet', url)
        .then((data) => {
          commit('setRestrictionList', data.restrict_list)
          commit('setRestrictionTotalCount', data.total_count)
        })
        .catch((error) => {
          throw error
        })
    },
    getRestrictionSingle ({commit, dispatch}, {id}) {
      const url = '/admin/restrict/' + id + '/single?access_token=' + this.getters.accessToken
      dispatch('apiGet', url)
        .then((data) => {
          commit('setRestrictionSingle', data.restrict)
        })
        .catch((error) => {
          throw error
        })
    },
    deleteRestriction ({commit, dispatch}, {id}) {
      let post = {
        data: {
          id: id
        }
      }

      post.url = '/admin/restrict/' + id + '/remove?access_token=' + this.getters.accessToken
      dispatch('apiPost', post)
        .then((data) => {
          commit('setSuccess', 'Ограничение удалено успешно')
        })
        .catch((error) => {
          throw error
        })
    },
    async createRestriction ({commit, dispatch}, restriction) {
      let post = {
        data: {
          title: restriction.title,
          start_date: restriction.startDate,
          end_date: restriction.endDate
        }
      }

      if (typeof restriction.pointFolderIdList !== 'undefined') {
        post.data.point_folder_id_list = restriction.pointFolderIdList
      }
      if (typeof restriction.pointIdList !== 'undefined') {
        post.data.point_id_list = restriction.pointIdList
      }
      if (typeof restriction.productCategoryIdList !== 'undefined') {
        post.data.product_category_id_list = restriction.productCategoryIdList
      }
      if (typeof restriction.productBrandIdList !== 'undefined') {
        post.data.product_category_brand_id_list = restriction.productBrandIdList
      }
      if (typeof restriction.productIdList !== 'undefined') {
        post.data.product_sku_id_list = restriction.productIdList
      }
      if (typeof restriction.channelIdList !== 'undefined') {
        post.data.distribution_channel_id_list = restriction.channelIdList
      }

      let returnData = null
      if (restriction.id === null) {
        post.url = '/admin/restrict/add?access_token=' + this.getters.accessToken
        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Ограничение создано успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      } else {
        post.id = restriction.id
        post.url = '/admin/restrict/' + restriction.id + '/update?access_token=' + this.getters.accessToken

        await dispatch('apiPost', post)
          .then((data) => {
            commit('setSuccess', 'Ограничение изменено успешно')
            returnData = data
          })
          .catch((error) => {
            throw error
          })
      }
      return returnData
    }
  },
  getters: {
    restrictionList (state) {
      return state.restrictionList
    },
    restrictionTotalCount (state) {
      return state.restrictionTotalCount
    },
    restrictionSingle (state) {
      return state.restrictionSingle
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/restriction.js